import { Loader } from '@/components/Loader';
import { useAutoTimezone } from '@/hooks/useAutoTimezone';
import { PropsWithChildren, useEffect, useState } from 'react';
import { useListStore } from '@/stores/list';
import { useAppointmentKioskFetch } from './hooks/useAppointmentKioskFetch';

export const PreloadQueriesKioskLayout = ({ children }: PropsWithChildren) => {
  const isUpdatingTimezone = useAutoTimezone('kiosk');
  const [isLoadingLists, setIsLoadingLists] = useState(true);

  const { getCountries, getTimezonesByKiosk } = useListStore((state) => ({
    getCountries: state.getCountries,
    getTimezonesByKiosk: state.getTimezonesByKiosk,
  }));

  useEffect(() => {
    const fetch = async () => {
      try {
        await Promise.all([getCountries(), getTimezonesByKiosk()]);
      } catch (e) {
        console.error('Failed to preload kiosk lists:', e);
      } finally {
        setIsLoadingLists(false);
      }
    };

    void fetch();
  }, [getCountries, getTimezonesByKiosk]);

  const isLoadingAppointments = useAppointmentKioskFetch();

  if (isUpdatingTimezone || isLoadingLists || isLoadingAppointments)
    return <Loader />;

  return children;
};
